"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatHeader = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _utils = require("../../../utils");
require("./ChatHeader.less");
var _CustomAvatar = require("../../GroupChats/components/CustomAvatar");
var _utils2 = require("../../GroupChats/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Text = _typography.default.Text;
var ChatHeader = function ChatHeader(_ref) {
  var _member$user;
  var member = _ref.member,
    onBack = _ref.onBack,
    clinicianPatients = _ref.clinicianPatients;
  var memberName = (0, _utils.composeName)([member === null || member === void 0 ? void 0 : member.user.lastName, member === null || member === void 0 ? void 0 : member.user.firstName]) || (member === null || member === void 0 ? void 0 : member.user.nickName);

  // These patients are only available in clinician app, we need it to replace nicknames for real names
  var replaceName = (0, _utils2.getSinglePatientNameByNickName)(member === null || member === void 0 ? void 0 : (_member$user = member.user) === null || _member$user === void 0 ? void 0 : _member$user.name, clinicianPatients);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-header"
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    align: "middle",
    justify: "start",
    gutter: 8
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "str-chat-channel-list-icon-back",
    onClick: onBack
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    className: "icon-arrow",
    type: "none"
  })), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "chat-header-avatar"
  }, /*#__PURE__*/_react.default.createElement(_CustomAvatar.CustomAvatar, {
    image: member === null || member === void 0 ? void 0 : member.user.image,
    name: member === null || member === void 0 ? void 0 : member.user.name,
    clinicianPatients: clinicianPatients
  })), /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "chat-header-name"
  }, (0, _utils.isPatient)({
    role: member === null || member === void 0 ? void 0 : member.user.applicationRole
  }) ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/patients/".concat(member === null || member === void 0 ? void 0 : member.user.nickName, "/info"),
    className: "label-small-medium"
  }, replaceName || memberName) : /*#__PURE__*/_react.default.createElement(Text, {
    className: "label-small-medium"
  }, memberName))));
};
exports.ChatHeader = ChatHeader;